import * as React from 'react';
import {Component} from 'react';
import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import {InjectedElementRefProps} from './withElementRef';

interface ScrollOnMoveProps {
    field: any;
}

export const withScrollOnMove = (InnerComponent: React.ComponentType<any>) => {
    @observer
    class ScrollOnMove<P> extends Component<
        P & ScrollOnMoveProps & InjectedElementRefProps & any,
        null
    > {
        reactions = [];

        constructor(props) {
            super(props);

            this.scrollIntoView = this.scrollIntoView.bind(this);
        }

        componentDidMount() {
            const {field} = this.props;
            this.reactions[0] = reaction(() => field.moved, this.scrollIntoView, {
                fireImmediately: true,
                delay: 50
            });
            this.reactions[1] = reaction(() => field.movedUp, this.scrollIntoView, {
                fireImmediately: true,
                delay: 50
            });
            this.reactions[2] = reaction(() => field.movedDown, this.scrollIntoView, {
                fireImmediately: true,
                delay: 50
            });
        }

        componentWillUnmount() {
            this.reactions.forEach(dispose => dispose());
        }

        scrollIntoView() {
            const {field, elementRef} = this.props;
            if (field.moved) {
                field.setMoved(false);
                if (this.isInvisible()) {
                    elementRef.current.scrollIntoView({
                        block: 'start',
                        inline: 'nearest',
                        behavior: 'smooth'
                    });
                }
            } else if (field.movedDown) {
                field.setMovedDown(false);
                if (this.isInvisible()) {
                    elementRef.current.scrollIntoView({
                        block: 'end',
                        inline: 'nearest',
                        behavior: 'smooth'
                    });
                }
            } else if (field.movedUp) {
                field.setMovedUp(false);
                if (this.isInvisible()) {
                    elementRef.current.scrollIntoView({
                        block: 'start',
                        inline: 'nearest',
                        behavior: 'smooth'
                    });
                }
            }
        }

        isInvisible() {
            const {elementRef} = this.props;
            return (
                elementRef.current.offsetTop < elementRef.current.offsetParent.scrollTop ||
                elementRef.current.offsetTop +
                    elementRef.current.clientHeight -
                    elementRef.current.offsetParent.scrollTop >
                    elementRef.current.offsetParent.clientHeight
            );
        }

        render() {
            return <InnerComponent {...this.props} />;
        }
    }
    return ScrollOnMove;
};
